/**
 * UserModals
 *
 * Collection of thin wrappers around shared UI modals for admin actions
 * (confirmations, subscription sync, cancel subscription, delete user).
 */
import React from 'react';
import { ConfirmationModal } from '../../ui/modals/confirmation-modal.jsx';
import SubscriptionSyncModal from '../../ui/modals/subscription-sync-modal.jsx';

export const UserConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  user, 
  title, 
  message,
  confirmText = "Confirm",
  cancelText = "Cancel"
}) => {
  return (
    <ConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      message={message}
      confirmText={confirmText}
      cancelText={cancelText}
    />
  );
};

export const UserSubscriptionSyncModal = ({
  isOpen,
  onClose,
  user,
  onSync
}) => {
  return (
    <SubscriptionSyncModal
      isOpen={isOpen}
      onClose={onClose}
      user={user}
      onSubmit={onSync}
    />
  );
};

export const DeleteUserModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  user,
  isLoading
}) => {
  const message = `Are you sure you want to delete the user account for ${user?.email || 'this user'}? This action will permanently delete:

• User's Firebase authentication account
• All user data and preferences
• All namespaces owned by this user
• All campaigns and survey videos
• All custom templates
• Stripe subscription and customer data
• All associated files and storage

This action cannot be undone.`;

  return (
    <UserConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      user={user}
      title="Delete User Account"
      message={message}
      confirmText={isLoading ? "Deleting..." : "Delete User"}
      cancelText="Cancel"
    />
  );
};

export const CancelSubscriptionModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  user 
}) => {
  return (
    <UserConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={() => onConfirm(user)}
      user={user}
      title="Cancel Subscription"
      message={`Are you sure you want to cancel the subscription for ${user?.displayName || user?.email}? They will be downgraded to a basic account.`}
      confirmText="Cancel Subscription"
      cancelText="Keep Subscription"
      loadingText="Cancelling..."
      confirmButtonVariant="primary"
    />
  );
};

const UserModals = {
  UserConfirmationModal,
  UserSubscriptionSyncModal,
  DeleteUserModal,
  CancelSubscriptionModal
};

export default UserModals; 